import { useContext } from 'react';
import { INewsArticleContext, NewsArticleContext } from './NewsArticleContext';
import './NewsArticleFeaturedImage.scss';

export function NewsArticleFeaturedImage() {
  const articleContext = useContext<INewsArticleContext>(NewsArticleContext);

  return (
    <>
      {articleContext && articleContext.article?.ShowFeaturedImage && (
        <div className="news-featured-image-container">
          <img src={articleContext.article.FeaturedImageSrc} alt={articleContext.article.Headline} />
        </div>
      )}
    </>
  );
}

export default NewsArticleFeaturedImage;
